/* eslint-disable eqeqeq */
export const cardNumberRegExp: RegExp = /^[0-9]{4}(?:\s?[0-9]{4}){3}$/;

// export const dateRegex: RegExp = /^(0[1-9]|1[0-2])\/\d{4}$/;

export const dateRegex: RegExp = /^(0[1-9]|1[0-2])\/(?:\d{2}|\d{4})$/;

export const cvvRegex: RegExp = /^\d{3,4}$/;

// /^[0-9]{3,4}$/;

export const cardHolderNameRegex: RegExp = /^.{1,30}$/;

export const doLuhnCheck = (value: string): boolean => {
  // The Luhn Algorithm.
  let nCheck = 0,
    nDigit = 0,
    bEven = false;
  value = value.replace(/\D/g, '');
  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    nDigit = parseInt(cDigit, 10);
    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 === 0;
};

// export const isFutureDate = (expiryDate: string): boolean => {
//   if (expiryDate.length < 7) {
//     return false;
//   }
//   const expiryDateParts = expiryDate.split('/');

//   const expiryMonth = Number(expiryDateParts[0]);
//   const expiryYear = Number(expiryDateParts[1]);
//   const now = new Date();
//   const month = now.getMonth() + 1; // Date are zero based in JavaScript e.g. Jan = 0. So we convert this here.
//   const year = now.getFullYear();
//   return expiryYear > year || (expiryYear == year && expiryMonth >= month);
// };

export const isFutureDate = (expiryDate: string): boolean => {
  if (expiryDate.length < 5) {
    return false;
  }

  const now = new Date();
  const currentYear = now.getFullYear() % 100; // Extract last two digits of the current year

  const [expiryMonth, expiryYear] = expiryDate.split('/').map(Number);

  if (isNaN(expiryMonth) || isNaN(expiryYear)) {
    return false; // Invalid format, return false
  }

  return expiryYear > currentYear || (expiryYear === currentYear && expiryMonth >= now.getMonth() + 1);
};
